import styled from "styled-components";

const UserPersonalReplySc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;

  height: 90vh;
  padding-top: 10px;
  .heading {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
  }

  .container_reply {
    background-color: #f2f2f2;
    border-radius: 5px;
    width: 80%;
    height: 100%;
    margin: 1rem auto;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .member_name {
    background-color: #4285f4;
    border-radius: 4px;
    padding: 0.5rem 2rem;
    color: #fff;
    font-weight: bold;
  }
  .faq_type {
    background-color: #4285f4;
    border-radius: 4px;
    padding: 0.5rem 2rem;
    color: #fff;
    font-weight: bold;
  }
  .query_content {
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;

    align-content: center;
    padding: 2rem 4rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  .goals-conatiner {
    margin-top: 3rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .goal-content {
    margin-top: 3rem;
    width: 100%;
    background-color: #fff;
    border-radius: 4px;
    align-content: center;
    padding: 2rem 4rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  .response_tab {
    width: 100%;
  }
  .submit_button {
    display: flex;
    justify-content: flex-end;
    justify-self: flex-end;
  }
`;

export default UserPersonalReplySc;
